import { IClientTeam } from '~/services/api/clientDetails/types';

interface IFilters {
  teams: number[];
  status: number;
}
interface IGetCurrentTeamsResult {
  archived: IClientTeam[];
  active: IClientTeam[];
}

const getCurrentClientTeams = (teams: IClientTeam[], filters: IFilters): IGetCurrentTeamsResult => {
  const archived = [];
  const active = [];

  const { teams: selectedFilterTeams, status } = filters;
  const currentTeams =
    selectedFilterTeams.length > 0
      ? // Applied filters: teams = selected
        teams.filter(item => selectedFilterTeams.includes(item.team.id))
      : // Applied filters: teams = all
        teams;

  // Applied filters: status = all
  if (status === 0) {
    archived.push(...currentTeams.filter(item => item.isArchived));
    active.push(...currentTeams.filter(item => !item.isArchived));
  }

  // Applied filters: status = active
  if (status === 2) {
    active.push(...currentTeams.filter(item => !item.isArchived));
  }

  // Applied filters: status = archived
  if (status === 1) {
    archived.push(...currentTeams.filter(item => item.isArchived));
  }

  return { archived, active };
};

export default getCurrentClientTeams;
